/* Vietiki search:
   - photo swatches switch the tile's photo, price and link
     (mouse: on hover; touch: first tap previews, second tap opens)
   - clicking a key shape with several versions opens the list of versions
     (material, photo, price) under the tiles; each version links to its page
   - the "before typing" panel (brands, categories) is added to every search box
     on the page, e.g. the mobile bottom-bar search
   - languages Shopify's instant search does not support (e.g. Japanese) fall back
     to the normal store search, so the dropdown still works. */
(function () {
  if (window.vkSearchReady) return;
  window.vkSearchReady = true;

  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (event) {
    lastPointer = event.pointerType || 'mouse';
  }, true);

  function isTouch() {
    return lastPointer !== 'mouse' || (window.matchMedia && window.matchMedia('(hover: none)').matches);
  }

  function select(sw) {
    var tile = sw.closest('.vk-shape');
    if (!tile) return;
    var main = tile.querySelector('.vk-shape__main');
    var img = tile.querySelector('.vk-shape__media > img');
    var price = tile.querySelector('.vk-shape__price');
    if (img && sw.dataset.img) img.src = sw.dataset.img;
    if (main && !main.hasAttribute('data-vk-opts')) main.href = sw.href;
    if (price && sw.dataset.price) price.textContent = sw.dataset.price;
    tile.querySelectorAll('.vk-sw').forEach(function (el) {
      el.classList.toggle('is-active', el === sw);
    });
  }

  function onHover(event) {
    if (isTouch()) return;
    var sw = event.target.closest && event.target.closest('.vk-sw');
    if (sw) select(sw);
  }

  function onTap(event) {
    var sw = event.target.closest && event.target.closest('.vk-sw');
    if (!sw || !isTouch()) return;
    if (sw.classList.contains('is-active')) return;
    event.preventDefault();
    event.stopPropagation();
    select(sw);
  }

  /* Versions panel */
  function resetList(list) {
    if (!list) return;
    list.querySelectorAll('[data-vk-opts]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    list.querySelectorAll('.vk-shape.is-open').forEach(function (t) { t.classList.remove('is-open'); });
  }

  function toggleOptions(main) {
    var tile = main.closest('.vk-shape');
    var list = tile && tile.parentElement;
    var host = list && list.nextElementSibling;
    var tpl = tile && tile.querySelector('template.vk-opts-tpl');
    if (!host || !host.classList.contains('vk-opts-host') || !tpl) return false;
    var wasOpen = main.getAttribute('aria-expanded') === 'true';
    resetList(list);
    if (wasOpen) {
      host.hidden = true;
      return true;
    }
    host.querySelector('.vk-opts-host__title').textContent = tpl.getAttribute('data-title') || '';
    var ul = host.querySelector('.vk-opts');
    ul.innerHTML = '';
    ul.appendChild(tpl.content.cloneNode(true));
    main.setAttribute('aria-expanded', 'true');
    tile.classList.add('is-open');
    host.hidden = false;
    if (host.scrollIntoView) host.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    return true;
  }

  function onOptionsClick(event) {
    if (!event.target.closest) return;
    var close = event.target.closest('.vk-opts-host__close');
    if (close) {
      event.preventDefault();
      var host = close.closest('.vk-opts-host');
      host.hidden = true;
      resetList(host.previousElementSibling);
      return;
    }
    var main = event.target.closest('.vk-shape__main[data-vk-opts]');
    if (main && toggleOptions(main)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function addStartPanels() {
    var source = document.querySelector('.vk-start');
    if (!source) return;
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.querySelector('.vk-start')) return;
      var results = ps.querySelector('[data-predictive-search]');
      if (!results) return;
      var copy = source.cloneNode(true);
      results.after(copy);
    });
  }

  function patchPredictiveSearch() {
    var C = customElements.get('predictive-search');
    if (!C || C.prototype.vkPatched) return;
    C.prototype.vkPatched = true;
    C.prototype.getSearchResults = function (searchTerm) {
      var self = this;
      var queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
      var q = encodeURIComponent(searchTerm);
      var primary = routes.predictive_search_url + '?q=' + q + '&section_id=predictive-search';
      var searchUrl = routes.search_url || routes.predictive_search_url.replace(/\/suggest$/, '');
      var fallback = searchUrl + '?q=' + q + '&type=product&options%5Bprefix%5D=last&section_id=predictive-search';
      var signal = this.abortController.signal;
      var get = function (url) { return fetch(url, { signal: signal }); };
      var request = window.vkSearchFallback
        ? get(fallback)
        : get(primary).then(function (r) {
            if (r.status === 417) {
              window.vkSearchFallback = true;
              return get(fallback);
            }
            return r;
          });
      request
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (text) {
          var el = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!el) { self.close(); return; }
          var markup = el.innerHTML;
          self.allPredictiveSearchInstances.forEach(function (i) { i.cachedResults[queryKey] = markup; });
          self.renderSearchResults(markup);
        })
        .catch(function (error) {
          if (error && (error.name === 'AbortError' || error.code === 20)) return;
          self.close();
        });
    };
  }

  document.addEventListener('mouseover', onHover);
  document.addEventListener('focusin', onHover);
  document.addEventListener('click', onTap, true);
  document.addEventListener('click', onOptionsClick, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addStartPanels);
  else addStartPanels();
  if (window.customElements) customElements.whenDefined('predictive-search').then(patchPredictiveSearch);
})();
